import type { GetSitemapContentQueryVariables } from "@ihr-radioedit/inferno-webapi";
import { getSdk, sdkOpts } from "./sdk";
import { addSurrogateKeys } from "../lib/cache";

const sdk = getSdk(sdkOpts());

export const getHistoricalContent = (query: GetSitemapContentQueryVariables) =>
  sdk!.GetHistoricalContent.queryAsPromise(query).then(
    r => r.data?.pubsub?.query || { items: [], page: { nextToken: null } },
  );

export const getSitemapContent = (query: GetSitemapContentQueryVariables, surrogateKeys?: Set<string>) => {
  return sdk!.GetSitemapContent.queryAsPromise(query).then(response => {
    if (surrogateKeys && response.data) {
      addSurrogateKeys(response, surrogateKeys);
    }
    return response.data?.pubsub?.query?.items || [];
  });
};
